import { createFileRoute } from "@tanstack/react-router";
import { Navbar, Footer } from "@/components/hilltop";
import { Leadership } from "@/components/hilltop/Leadership";

export const Route = createFileRoute("/_public/leadership")({
  component: LeadershipPage,
});

function LeadershipPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Leadership />
      <Footer />
    </div>
  );
}
